'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAllLineItems = exports.removeLineItem = exports.updateLineItem = exports.addItemToCart = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.setItemBeingAddedId = setItemBeingAddedId;
exports.setLoading = setLoading;
exports.addError = addError;
exports.toggleError = toggleError;
exports.removeError = removeError;
exports.removeAllErrors = removeAllErrors;
exports.updateLineItems = updateLineItems;

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _errors = require('../../modules/bao-cart/errors');

var _pushCartTypes = require('../types/push-cart-types');

var pushCartTypes = _interopRequireWildcard(_pushCartTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var addItemToCart = exports.addItemToCart = function addItemToCart(_ref) {
  var id = _ref.id,
      properties = _ref.properties,
      quantity = _ref.quantity;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(setLoading(true));

              _context.prev = 1;
              _context.next = 4;
              return shopifyCart.addItem(id, { properties: properties, quantity: quantity });

            case 4:
              _context.next = 6;
              return shopifyCart.getState();

            case 6:
              data = _context.sent;

              dispatch(updateLineItems(data));

            case 8:
              _context.prev = 8;

              dispatch(setLoading(false));
              return _context.finish(8);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1,, 8, 11]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var updateLineItem = exports.updateLineItem = function updateLineItem(_ref3) {
  var lineItem = _ref3.lineItem,
      quantity = _ref3.quantity,
      properties = _ref3.properties;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var data, wantedQuantity, actualQuantity, wantedQuantityAndActualQuantityAreTheSame;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return shopifyCart.updateItem(lineItem.key, {
                quantity: quantity,
                properties: (0, _assign2.default)({}, lineItem.properties, properties)
              });

            case 2:
              data = _context2.sent;
              wantedQuantity = quantity;
              actualQuantity = data.items.find(function (item) {
                return item.key === lineItem.key;
              }).quantity;
              wantedQuantityAndActualQuantityAreTheSame = wantedQuantity === actualQuantity;

              dispatch(updateLineItems(data));

              if (!wantedQuantityAndActualQuantityAreTheSame) {
                dispatch(addError((0, _errors.ADD_TOO_MANY_ERROR)(wantedQuantity, actualQuantity, lineItem.title)));
              }

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var removeLineItem = exports.removeLineItem = function removeLineItem(_ref5) {
  var lineItem = _ref5.lineItem;

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return shopifyCart.removeItem(lineItem.key);

            case 2:
              data = _context3.sent;

              dispatch(updateLineItems(data));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var removeAllLineItems = exports.removeAllLineItems = function removeAllLineItems() {
  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(setLoading(true));

              _context4.next = 3;
              return shopifyCart.clearItems();

            case 3:
              data = _context4.sent;

              dispatch(updateLineItems(data));

              dispatch(setLoading(false));

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
};

function setItemBeingAddedId(id) {
  return {
    type: pushCartTypes.SET_ITEM_BEING_ADDED_ID,
    payload: { id: id }
  };
}

function setLoading(isLoading) {
  return {
    type: pushCartTypes.SET_LOADING,
    payload: isLoading
  };
}

function addError(message) {
  return {
    type: pushCartTypes.ADD_ERROR,
    payload: {
      error: (0, _assign2.default)({}, {
        key: new Date(),
        show: true,
        message: message
      })
    }
  };
}

function toggleError(key) {
  return {
    type: pushCartTypes.TOGGLE_ERROR,
    payload: { key: key }
  };
}

function removeError(key) {
  return {
    type: pushCartTypes.REMOVE_ERROR,
    payload: { key: key }
  };
}

function removeAllErrors() {
  return {
    type: pushCartTypes.REMOVE_ALL_ERRORS
  };
}

function updateLineItems(data) {
  return {
    type: pushCartTypes.UPDATE_LINE_ITEMS,
    payload: { data: data }
  };
}